import React from 'react';
import { Checkbox, Flex, Text } from 'UI';

export interface NotificationCheckboxProps {
  key: string;
  label: string;
  checked: boolean;
  onChange: (enabled: boolean) => void;
  disabled?: boolean;
}

export const NotificationCheckbox = ({ label, checked, onChange, disabled = false }: NotificationCheckboxProps) => {
  return (
    <Flex direction={'row'} gap={7} minWidth={100}>
      <Checkbox checked={checked} onChange={onChange} disabled={disabled} />
      <Text type="base">{label}</Text>
    </Flex>
  );
};
